import React, { useEffect, useState } from 'react';
import './contact_redesign.css';
import { AppointReq } from '../Functions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import MetaTags from '../meta';
import { tags } from '../Data/metaTags';

// Images (using placeholders)
import quotationHero from '../assets/contact/contact.jpg'; // Reuse or find better

const QuotationPage = () => {
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const notify = () => toast.info("Quotation request received. Our team will contact you.", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark"
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);
        
        // Mock data submission
        const data = {
            id: (new Date().getTime()).toString(),
            email: "quotation@example.com", 
            des: "Bulk Order Quotation",
            phone: "",
            orders: "50+", // Example
            name: "",
            organization: "Tech Corp"
        };
        
        await AppointReq(data);
        notify();
        setLoad(false);
        setTimeout(() => navigate("/"), 2000);
    };

    return (
        <div className="bg-[#0A0A0B] min-h-screen text-white font-sans pb-20" style={{fontFamily: 'var(--font-body)'}}>
            <MetaTags data={tags.reachus} /> 
            <ToastContainer position="bottom-center" theme="dark" />

            {/* 1. Hero / Quotation (Full Height) */}
            <section className="relative min-h-screen flex flex-col justify-center items-center px-4 pt-20 pb-12 overflow-hidden">
                {/* Background overlay/effect */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B] via-[#001427]/20 to-[#0A0A0B] z-0 pointer-events-none"></div>
                
                <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col items-center">
                    <div className="text-center mb-16 animate-fade-in-up">
                        <div className="flex items-center justify-center gap-4 mb-6">
                            <div className="h-[1px] w-16 md:w-24 bg-gradient-to-r from-transparent to-[#D4AF37]"></div>
                            <span className="uppercase tracking-[0.3em] text-[#D4AF37] text-sm md:text-base font-medium">Bespoke Solutions</span>
                            <div className="h-[1px] w-16 md:w-24 bg-gradient-to-l from-transparent to-[#D4AF37]"></div>
                        </div>
                        <h1 className="text-5xl md:text-7xl mb-6 text-white" style={{fontFamily: 'var(--font-heading)', textShadow: '0 4px 20px rgba(0,0,0,0.5)'}}>
                            Bulk & Corporate <span className="text-[#D4AF37]">Orders</span>
                        </h1>
                        <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto font-light leading-relaxed">
                            Elevate your team's presence with Maviinci's premium corporate tailoring solutions.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
                        {/* Interactive Features Cards */}
                        <div className="group flex flex-col items-center p-8 bg-[#001427] rounded-xl border border-[#1a2b40] transform transition-all duration-500 hover:-translate-y-4 hover:border-[#D4AF37]/50 shadow-2xl relative overflow-hidden">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37]/5 rounded-bl-full transition-transform duration-500 group-hover:scale-110"></div>
                            <div className="w-16 h-16 bg-[#0A0A0B] rounded-full flex items-center justify-center mb-6 border border-[#D4AF37]/30 text-[#D4AF37]">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                                </svg>
                            </div>
                            <h3 className="text-2xl font-medium text-white tracking-wide mb-3" style={{fontFamily: 'var(--font-heading)'}}>Premium Branding</h3>
                            <p className="text-gray-400 text-center text-sm leading-relaxed">From subtle embroidery to custom linings, we integrate your brand identity into every garment.</p>
                            <div className="h-[2px] w-0 bg-[#D4AF37] mt-6 transition-all duration-500 group-hover:w-16"></div>
                        </div>

                        <div className="group flex flex-col items-center p-8 bg-[#001427] rounded-xl border border-[#1a2b40] transform transition-all duration-500 hover:-translate-y-4 hover:border-[#D4AF37]/50 shadow-2xl relative overflow-hidden md:mt-12">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37]/5 rounded-bl-full transition-transform duration-500 group-hover:scale-110"></div>
                            <div className="w-16 h-16 bg-[#0A0A0B] rounded-full flex items-center justify-center mb-6 border border-[#D4AF37]/30 text-[#D4AF37]">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                                </svg>
                            </div>
                            <h3 className="text-2xl font-medium text-white tracking-wide mb-3" style={{fontFamily: 'var(--font-heading)'}}>Unmatched Quality</h3>
                            <p className="text-gray-400 text-center text-sm leading-relaxed">Using only premium fabrics from world-renowned mills, ensuring durability and comfort.</p>
                            <div className="h-[2px] w-0 bg-[#D4AF37] mt-6 transition-all duration-500 group-hover:w-16"></div>
                        </div>

                        <div className="group flex flex-col items-center p-8 bg-[#001427] rounded-xl border border-[#1a2b40] transform transition-all duration-500 hover:-translate-y-4 hover:border-[#D4AF37]/50 shadow-2xl relative overflow-hidden">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37]/5 rounded-bl-full transition-transform duration-500 group-hover:scale-110"></div>
                            <div className="w-16 h-16 bg-[#0A0A0B] rounded-full flex items-center justify-center mb-6 border border-[#D4AF37]/30 text-[#D4AF37]">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                            </div>
                            <h3 className="text-2xl font-medium text-white tracking-wide mb-3" style={{fontFamily: 'var(--font-heading)'}}>Seamless Logistics</h3>
                            <p className="text-gray-400 text-center text-sm leading-relaxed">Dedicated account managers and door-step measurement sessions for teams of any size.</p>
                            <div className="h-[2px] w-0 bg-[#D4AF37] mt-6 transition-all duration-500 group-hover:w-16"></div>
                        </div>
                    </div>
                    
                    {/* Scroll Indicator */}
                    <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-50 hidden md:block">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 5v14M19 12l-7 7-7-7"/>
                        </svg>
                    </div>
                </div>
            </section>

            <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

            {/* 2. Process Section */}
            <section className="py-12 px-4 max-w-7xl mx-auto">
                <div className="text-center mb-12">
                    <div className="flex items-center justify-center gap-4 mb-10">
                        <div className="h-[1px] w-12 bg-[#D4AF37] opacity-50"></div>
                        <h2 className="text-3xl md:text-4xl" style={{fontFamily: 'var(--font-heading)'}}>How We <span className="text-[#D4AF37]">Work</span></h2>
                        <div className="h-[1px] w-12 bg-[#D4AF37] opacity-50"></div>
                    </div>

                    <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 max-w-4xl mx-auto">
                        <div className="flex flex-col items-center text-center max-w-[200px]">
                            <div className="w-24 h-24 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-4 text-[#D4AF37] text-3xl" style={{fontFamily: 'var(--font-heading)'}}>
                                01
                            </div>
                            <h3 className="text-white font-medium mb-1">Consultation</h3>
                            <p className="text-gray-400 text-xs">We understand your brand needs and suggest styles.</p>
                        </div>
                        
                        <div className="hidden md:block text-[#D4AF37] text-3xl">»</div>
                        
                        <div className="flex flex-col items-center text-center max-w-[200px]">
                            <div className="w-24 h-24 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-4 text-[#D4AF37] text-3xl" style={{fontFamily: 'var(--font-heading)'}}>
                                02
                            </div>
                            <h3 className="text-white font-medium mb-1">Sampling</h3>
                            <p className="text-gray-400 text-xs">Prototypes are created for your approval.</p>
                        </div>

                        <div className="hidden md:block text-[#D4AF37] text-3xl">»</div>

                        <div className="flex flex-col items-center text-center max-w-[200px]">
                            <div className="w-24 h-24 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-4 text-[#D4AF37] text-3xl" style={{fontFamily: 'var(--font-heading)'}}>
                                03
                            </div>
                            <h3 className="text-white font-medium mb-1">Measurement</h3>
                            <p className="text-gray-400 text-xs">Our tailors visit your location for precise sizing.</p>
                        </div>

                        <div className="hidden md:block text-[#D4AF37] text-3xl">»</div>

                        <div className="flex flex-col items-center text-center max-w-[200px]">
                            <div className="w-24 h-24 rounded-full border-2 border-[#D4AF37] flex items-center justify-center mb-4 text-[#D4AF37] text-3xl" style={{fontFamily: 'var(--font-heading)'}}>
                                04
                            </div>
                            <h3 className="text-white font-medium mb-1">Delivery</h3>
                            <p className="text-gray-400 text-xs">Packaged and delivered with a guaranteed fit.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-700 to-transparent my-8"></div>

            {/* 3. Form & Catchphrase Section (2 Columns) */}
            <section className="py-20 px-4 max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                    {/* Left Column: Catch Phrase & Details */}
                    <div className="flex flex-col gap-8 lg:sticky lg:top-24">
                        <div>
                            <div className="flex items-center gap-4 mb-4">
                                <div className="h-[1px] w-12 bg-[#D4AF37]"></div>
                                <span className="uppercase tracking-widest text-[#D4AF37] text-sm font-medium">Partner With Us</span>
                            </div>
                            <h2 className="text-4xl md:text-5xl text-white leading-tight mb-6" style={{fontFamily: 'var(--font-heading)'}}>
                                Your Brand, <br/><span className="text-[#D4AF37]">Expertly Tailored</span>
                            </h2>
                            <p className="text-gray-400 text-lg leading-relaxed mb-8">
                                At Maviinci, we believe a uniform is more than just clothing; it's a statement of your company's values and professionalism. Our corporate program offers end-to-end customization that aligns perfectly with your brand's aesthetic.
                            </p>
                        </div>

                        {/* Stats Grid */}
                        <div className="grid grid-cols-2 gap-6">
                            <div className="bg-[#001427]/50 p-6 rounded-lg border-t-2 border-[#D4AF37] backdrop-blur-sm text-center">
                                <div className="text-4xl text-[#D4AF37] mb-2" style={{fontFamily: 'var(--font-heading)'}}>50+</div>
                                <div className="text-sm text-gray-400 uppercase tracking-wider">Corporate Clients</div>
                            </div>
                            <div className="bg-[#001427]/50 p-6 rounded-lg border-t-2 border-[#D4AF37] backdrop-blur-sm text-center">
                                <div className="text-4xl text-[#D4AF37] mb-2" style={{fontFamily: 'var(--font-heading)'}}>10k+</div>
                                <div className="text-sm text-gray-400 uppercase tracking-wider">Suits Delivered</div>
                            </div>
                            <div className="bg-[#001427]/50 p-6 rounded-lg border-t-2 border-[#D4AF37] backdrop-blur-sm text-center col-span-2">
                                <div className="text-4xl text-[#D4AF37] mb-2" style={{fontFamily: 'var(--font-heading)'}}>100%</div>
                                <div className="text-sm text-gray-400 uppercase tracking-wider">Fit Guarantee</div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Form */}
                    <div className="bg-[#001427] p-8 md:p-10 rounded-xl shadow-2xl border border-gray-800 relative overflow-hidden">
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
                        
                        <div className="mb-8">
                            <h3 className="text-2xl text-white mb-2" style={{fontFamily: 'var(--font-heading)'}}>Request a Quote</h3>
                            <p className="text-gray-400 text-sm">Tell us about your organization's needs and our corporate team will get back to you.</p>
                        </div>

                        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                            <div className="group">
                                <input 
                                    type="text" 
                                    placeholder="Contact Person Name *" 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600" 
                                    required 
                                />
                            </div>
                            
                            <div className="group">
                                <input 
                                    type="text" 
                                    placeholder="Company / Organization Name *" 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600" 
                                    required 
                                />
                            </div>
                            
                            <div className="group">
                                <input 
                                    type="email" 
                                    placeholder="Business Email *" 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600" 
                                    required 
                                />
                            </div>

                            <div className="group">
                                <input 
                                    type="tel" 
                                    placeholder="Phone Number *" 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600" 
                                    required 
                                />
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <div className="group">
                                    <input 
                                        type="number" 
                                        placeholder="Approx. Qty *" 
                                        className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600" 
                                        required 
                                    />
                                </div>
                                <div className="group">
                                    <input 
                                        type="text" 
                                        placeholder="Timeline" 
                                        className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600" 
                                    />
                                </div>
                            </div>

                            <div className="group">
                                <textarea 
                                    placeholder="Describe your requirements (e.g. Uniforms, Corporate suits...)" 
                                    className="w-full bg-[#0A0A0B] border border-gray-800 text-white p-4 rounded-lg focus:outline-none focus:border-[#D4AF37] transition-all group-hover:border-gray-600 h-32 resize-none" 
                                    required
                                ></textarea>
                            </div>
                            
                            <button 
                                type="submit" 
                                disabled={load}
                                className="w-full bg-[#D4AF37] text-black font-bold py-4 mt-4 rounded-lg hover:bg-[#b08d4a] transition-all disabled:opacity-70 transform hover:-translate-y-1 hover:shadow-lg shadow-[#D4AF37]/20 text-lg"
                            >
                                {load ? 'Submitting...' : 'Get Quote'}
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default QuotationPage;